import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  ButtonGroup,
  Input,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
} from "reactstrap";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import DataTable from "react-data-table-component";
import StatusUpdateModal from "../component/StatusUpdateModal";
import OrderServices from "../../../services/OrderingServices/OrderServices";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { formatDateTime } from "../../../Components/Common/FormatDate";
import CancelModal from "../component/CancelModal";
import Select from "react-select";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const OrderList = () => {
  const navigate = useNavigate();
  const [itemList, setItemList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const selectedTable = JSON.parse(localStorage.getItem("selectedTable"));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const toggleModal = (item) => {
    setIsModalOpen(!isModalOpen);
    setSelectedItem(item);
  };
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  // Filter states
  const [filters, setFilters] = useState({
    paymentStatus: null,
    orderStatus: null,
    name: "",
    orderReferenceNo: "",
    tableName: "",
  });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);

  //Table state
  const [tableOptions, setTableOptions] = useState([]);

  // Modal states
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRefNumber, setSelectedRefNumber] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  const getStatusBadge = (status) => {
    const statusStyles = {
      Ordered: "bg-warning",
      Preparing: "bg-secondary",
      Ready: "bg-primary",
      Completed: "bg-success",
      Cancelled: "bg-danger",
    };

    return (
      <span className={`badge ${statusStyles[status] || "bg-primary"}`}>
        {status || "No Data"}
      </span>
    );
  };

  const getPaymentBadge = (e) => {
    const statusStyles = {
      Paid: "bg-success",
      Pending: "bg-warning",
      Failed: "bg-danger",
      Processing: "bg-secondary",
      Refunded: "bg-primary",
      PartiallyRefunded: "bg-secondary",
      OrderCancelled: "bg-danger",
      Completed: "bg-success",
      Chargeback: "bg-secondary",
    };
    return (
      <span className={`badge ${statusStyles[e] || "bg-danger"}`}>
        {e || "No Data"}
      </span>
    );
  };
  // const fetchAllOrdersForTables = async () => {
  //   try {
  //     const response = await OrderServices.getOrderList({
  //       pageNumber: 1,
  //       perPage: 1000, // large number to get all orders
  //       orderReferenceNo: debouncedFilters.orderReferenceNo,
  //       orderStatus: debouncedFilters?.orderStatus,
  //       paymentStatus: debouncedFilters?.paymentStatus,
  //       tableId: debouncedFilters?.tableId,
  //     });

  //     const tables = [
  //       ...new Map(
  //         response.items
  //           .filter((item) => item.tableId && item.tableName)
  //           .map((item) => [
  //             item.tableId,
  //             { value: item.tableId, label: item.tableName },
  //           ])
  //       ).values(),
  //     ];

  //     setTableOptions(tables);
  //   } catch (err) {
  //     console.error("Failed to fetch tables:", err);
  //   }
  // };

  const fetchAllOrdersForTables = async (
    page = currentPage,
    size = perPage,
    currentFilters = debouncedFilters
  ) => {
    try {
      const response = await OrderServices.getOrderList({
        pageNumber: page,
        perPage: size,
        orderReferenceNo: currentFilters.orderReferenceNo,
        orderStatus: currentFilters?.orderStatus,
        paymentStatus: currentFilters?.paymentStatus,
        tableId: currentFilters?.tableId,
      });

      const tables = [
        ...new Map(
          response.items
            .filter((item) => item.tableId && item.tableName)
            .map((item) => [
              item.tableId,
              { value: item.tableId, label: item.tableName },
            ])
        ).values(),
      ];

      setTableOptions(tables);
    } catch (err) {
      console.error("Failed to fetch tables:", err);
    }
  };

  const fetchOrderList = async (
    page = currentPage,
    size = perPage,
    currentFilters = debouncedFilters
  ) => {
    try {
      setLoading(true);
      const response = await OrderServices.getOrderList({
        pageNumber: page,
        perPage: size,
        orderReferenceNo: currentFilters.orderReferenceNo,
        orderStatus: currentFilters?.orderStatus,
        paymentStatus: currentFilters?.paymentStatus,
        tableId: currentFilters?.tableId,
      });
      console.log("🚀 ~ fetchOrderList ~ response:", response);

      const statusMap = {
        Ongoing: "Ongoing",
        Completed: "Completed",

        Cancelled: "Cancelled",
      };

      const paymentMap = {
        Pending: "Pending",
        Paid: "Paid",
        Failed: "Failed",
        Refunded: "Refunded",
        OrderCancelled: "Cancelled",
      };

      const indexedData = response.items.map((item, index) => ({
        ...item,
        sn: (page - 1) * size + index + 1,
        customerName: "", // Adjust if you have actual customer data
        customerId: null,
        orderRefrenceNumber: item.orderRefrenceId,
        createdDate: item.createdAt,
        orderStatus: statusMap[item.orderStatus] || "Unknown",
        paymentStatus: paymentMap[item.paymentStatus] || "Unknown",
        finalAmount: item.grandTotal,
        // tableName: item.tableName || item.tableName || "N/A",

        tableName: item.tableName || "N/A",
      }));

      // Generate table filter options
      const tables = [
        ...new Map(
          response.items
            .filter((item) => item.tableId && item.tableName) // only valid ones
            .map((item) => [
              item.tableId,
              { value: item.tableId, label: item.tableName },
            ])
        ).values(),
      ];

      setTableOptions(tables);

      setItemList(indexedData);
      setTotalRows(response.totalCount);
      fetchAllOrdersForTables(currentPage, perPage, debouncedFilters); // Fetch tables for filter
      setLoading(false);
    } catch (err) {
      toast.error("Failed to fetch order list");
      console.error("Error fetching Order List:", err);
      setLoading(false);
    }
  };

  // Debounce filter changes
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedFilters(filters);
      setCurrentPage(1); // Reset to first page on filter change
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [filters]);

  // Fetch orders when page, size, or debounced filters change
  useEffect(() => {
    fetchOrderList(currentPage, perPage);
  }, [currentPage, perPage, debouncedFilters]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => {
      const newFilters = { ...prev, [name]: value };
      console.log("🔍 Updated filters (text input):", newFilters);
      return newFilters;
    });
  };

  const handleCancel = async () => {
    try {
      const response = await OrderServices.cancelOrder(selectedItem?.id);
      fetchOrderList();
      toggleModal();
      toast.success(response);
      // toast.success(response);
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      name: "S.N",
      selector: (row) => row.sn,
      sortable: true,
      width: "75px",
    },

    {
      name: "Ref No",
      selector: (row) => row.orderRefrenceNumber,
      cell: (row) => (
        <Link to={`/order/${row.orderRefrenceNumber}`}>
          {row.orderRefrenceNumber}
        </Link>
      ),
      sortable: true,
      width: "14vw",
    },
    {
      name: "Ordered Date",
      selector: (row) => formatDateTime(row.createdDate),
      sortable: true,
      width: "14vw",
    },

    {
      name: "Table",
      selector: (row) => row.tableName || "-",
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => row.orderStatus || "No data available",
      cell: (row) => getStatusBadge(row.orderStatus),
      sortable: true,
      center: true,
    },
    {
      name: "Payment",
      selector: (row) => row.paymentStatus || "-",
      cell: (row) => getPaymentBadge(row.paymentStatus),
      sortable: true,
      center: true,
    },

    {
      name: "Amount",
      selector: (row) => row.finalAmount || 0,
      sortable: true,
      right: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div
          className={`${
            row.orderStatus == "Cancelled" ||
            (row.orderStatus === "Completed" && row.paymentStatus === "Paid")
              ? "d-none"
              : "d-block"
          }`}
        >
          <ButtonGroup size="sm">
            <Button
              color="btn btn-soft-danger"
              className="btn-sm gap-1 ms-1"
              // size="sm"
              onClick={() => {
                toggleModal(row);
              }}
              disabled={row.orderStatus === "Completed"}
            >
              {row?.orderStatus === 5 ? "Cancelled" : "Cancel"}
            </Button>
          </ButtonGroup>
        </div>
      ),
      center: true,
      width: "150px",
    },
  ];
  const orderStatusOption = [
    { value: 1, label: "Ongoing" },
    { value: 2, label: "Completed" },
    { value: 3, label: "Cancelled" },
  ];
  const handleOrderStatusChange = (selectedOption) => {
    setFilters((prev) => ({
      ...prev,
      orderStatus: selectedOption?.value ?? null,
    }));
  };
  const paymentStatusOption = [
    { value: 2, label: "Paid" },
    { value: 1, label: "Pending" },
    // { value: 0, label: "Cancelled" },
  ];
  const handlePaymentStatusChange = (selectedOption) => {
    setFilters((prev) => ({
      ...prev,
      paymentStatus: selectedOption?.value ?? null,
    }));
  };
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Order Details List" pageTitle="Order Details" />
        <div className="d-lg-none d-md-none d-block mb-2">
          <Button color="success" onClick={() => setShowOffcanvas(true)}>
            <i class="bx bx-filter-alt"></i>
          </Button>
        </div>

        <Row className="gap-0 mb-3 d-lg-flex d-none">
          <Col xs={12} lg={3} className="mb-2">
            <Input
              type="text"
              name="orderReferenceNo"
              value={filters.orderReferenceNo}
              onChange={handleFilterChange}
              placeholder="Search by reference number"
            />
          </Col>

          <Col xs={12} lg={3} className="mb-2">
            <Select
              options={tableOptions}
              value={
                tableOptions.find(
                  (option) => option.value === filters.tableId
                ) || null
              }
              onChange={(selectedOption) => {
                const newFilters = {
                  ...filters,
                  tableId: selectedOption?.value ?? null, // store id
                };
                console.log("🔍 Updated filters (tableId):", newFilters);
                setFilters(newFilters);
              }}
              placeholder="Select by Table"
              className="fs-6"
              isClearable
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Col>

          <Col xs={12} lg={3} className="mb-2">
            <Select
              options={orderStatusOption}
              value={orderStatusOption.find(
                (option) => option.value === filters.orderStatus
              )}
              onChange={handleOrderStatusChange}
              placeholder="Select Order Status"
              className="fs-6"
              isClearable
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Col>

          <Col xs={12} lg={3} className="mb-2">
            <Select
              options={paymentStatusOption}
              value={paymentStatusOption.find(
                (option) => option.value === filters.paymentStatus
              )}
              onChange={handlePaymentStatusChange}
              className="fs-6"
              placeholder="Select Payment Status"
              isClearable
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Col>
        </Row>
        <Offcanvas
          isOpen={showOffcanvas}
          toggle={() => setShowOffcanvas(!showOffcanvas)}
          direction="bottom"
          className="d-lg-none"
          style={{
            height: "80vh",
            borderTopLeftRadius: "1rem",
            borderTopRightRadius: "1rem",
            overflowY: "auto",
          }}
        >
          <OffcanvasHeader toggle={() => setShowOffcanvas(!showOffcanvas)}>
            <h3 className="text-lg font-semibold">Filters</h3>
          </OffcanvasHeader>
          <OffcanvasBody className="">
            <div className="">
              <div className="mb-2">
                <Label className="block text-sm font-medium mb-1">
                  Reference Number
                </Label>
                <Input
                  type="text"
                  name="orderReferenceNo"
                  value={filters.orderReferenceNo}
                  onChange={handleFilterChange}
                  placeholder="Search by reference number"
                  className="w-full p-2 border rounded-md text-sm"
                />
              </div>
              <div className="mb-2">
                <Label className="block text-sm font-medium mb-1">Table</Label>
                <Select
                  options={tableOptions}
                  value={
                    tableOptions.find(
                      (option) => option.value === filters.tableId
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    setFilters((prev) => ({
                      ...prev,
                      tableId: selectedOption?.value ?? null,
                    }))
                  }
                  placeholder="Select by Table"
                  className="text-sm"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
              <div className="mb-2">
                <Label className="block text-sm font-medium mb-1">
                  Order Status
                </Label>
                <Select
                  options={orderStatusOption}
                  value={orderStatusOption.find(
                    (option) => option.value === filters.orderStatus
                  )}
                  onChange={handleOrderStatusChange}
                  placeholder="Select Order Status"
                  className="text-sm"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
              <div className="mb-2">
                <Label className="block text-sm font-medium mb-1">
                  Payment Status
                </Label>
                <Select
                  options={paymentStatusOption}
                  value={paymentStatusOption.find(
                    (option) => option.value === filters.paymentStatus
                  )}
                  onChange={handlePaymentStatusChange}
                  placeholder="Select Payment Status"
                  className="text-sm"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>
          </OffcanvasBody>
          <div className="px-4 py-2 d-flex justify-content-end sticky-bottom bottom-0">
            <button
              className="btn btn-success"
              onClick={() => setShowOffcanvas(false)}
            >
              Apply Filters
            </button>
          </div>
        </Offcanvas>
        <div className="d-lg-block d-none">
          <DataTable
            responsive
            striped
            pagination
            fixedHeader
            highlightOnHover
            pointerOnHover
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            columns={columns}
            data={itemList}
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            paginationDefaultPage={currentPage}
            paginationPerPage={perPage}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
          />
        </div>
        <div className = "d-block d-lg-none">
        {loading ? (
          <div className="my-5 d-flex justify-content-center">
            <Triangle
              visible={true}
              height="60"
              width="60"
              color="#5B71B9"
              ariaLabel="triangle-loading"
            />
          </div>
        ) : (
          <>
            {itemList?.map((item, index) => (
              <Card
                key={item.id || index}
                className="mb-3 shadow-sm d-block d-lg-none mt-2"
                // onClick={(e) => {
                //   e.stopPropagation(); // prevents parent click handlers
                //   navigate(`/item/detail/${item?.id}`);
                // }}
              >
                <CardBody>
                  <Row>
                    <Col xs={10}>
                      <Link to={`/order/${item?.orderRefrenceNumber}`}>
                        <h6 className="mb-2 text-primary">{`${item.orderRefrenceNumber} `}</h6>
                      </Link>
                      <h6 className="mb-2 text-muted">
                        {formatDateTime(item?.createdDate)}
                      </h6>
                      <h6 className="mb-2 d-flex justify-content-between align-content-center align-items-center">
                        Table: {item?.tableName}
                      </h6>
                      <h6 className="mb-2 d-flex justify-content-between align-content-center align-items-center">
                        <strong>Amount:</strong> {item?.finalAmount || "none"}
                      </h6>
                      <h6 className="mb-2 d-flex justify-content-between align-content-center align-items-center">
                        <strong>Payment:</strong>{" "}
                        {getPaymentBadge(item.paymentStatus)}
                      </h6>
                      <h6 className="mb-0 d-flex justify-content-between align-content-center align-items-center">
                        <strong>Status: </strong>{" "}
                        {getStatusBadge(item.orderStatus)}
                      </h6>
                    </Col>
                    <Col xs={2}>
                      <div>
                        <Dropdown
                          isOpen={item.dropdownOpen || false}
                          toggle={(e) => {
                            e.stopPropagation(); // prevents parent click handlers
                            setItemList((prev) =>
                              prev.map(
                                (customer) =>
                                  customer.id === item.id
                                    ? {
                                        ...customer,
                                        dropdownOpen: !customer.dropdownOpen,
                                      }
                                    : { ...customer, dropdownOpen: false } // close all others
                              )
                            );
                          }}
                          direction="down"
                        >
                          <DropdownToggle
                            color="primary"
                            outline
                            className="btn-sm shadow-sm rounded-circle"
                          >
                            <i className="ri-more-2-fill"></i>
                          </DropdownToggle>
                          <DropdownMenu end>
                            <DropdownItem
                            // onClick={() => {
                            //   navigate(`/menu-item/update/${item?.id}`);
                            // }}
                            >
                              <i className="ri-edit-line text-warning me-2"></i>{" "}
                              Edit
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => handleDeleteClick(item.id)}
                            >
                              <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                              Delete
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ))}

            {/* Pagination for Mobile View */}
            {itemList?.length > 0 && (
              <div className="d-flex justify-content-center align-content-center align-items-center d-lg-none sticky-bottom bottom-0">
                <nav>
                  <ul className="pagination justify-content-center mb-0">
                    {/* Prev Button */}
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                      >
                        <i className="ri-arrow-left-s-line"></i>
                      </button>
                    </li>

                    {/* Page Numbers */}
                    {(() => {
                      const totalPages = Math.ceil(totalRows / perPage);
                      const maxVisible = 5;
                      let startPage = Math.max(
                        currentPage - Math.floor(maxVisible / 2),
                        1
                      );
                      let endPage = startPage + maxVisible - 1;

                      if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = Math.max(endPage - maxVisible + 1, 1);
                      }

                      return [...Array(endPage - startPage + 1)].map(
                        (_, index) => {
                          const page = startPage + index;
                          return (
                            <li
                              key={page}
                              className={`page-item ${
                                currentPage === page ? "active" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => setCurrentPage(page)}
                              >
                                {page}
                              </button>
                            </li>
                          );
                        }
                      );
                    })()}

                    {/* Next Button */}
                    <li
                      className={`page-item ${
                        currentPage === Math.ceil(totalRows / perPage)
                          ? "disabled"
                          : ""
                      }`}
                    >
                      {/* <button
                        className="page-link"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, Math.ceil(totalRows / perPage)),
                          )
                        }
                        disabled={
                          currentPage === Math.ceil(totalRows / perPage)
                        }
                      >
                        <i className="ri-arrow-right-s-line"></i>
                      </button> */}

                      {/* Prev Button */}

                      {/* Next Button */}
                      <button
                        className="page-link"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, Math.ceil(totalRows / perPage))
                          )
                        }
                        disabled={
                          currentPage === Math.ceil(totalRows / perPage)
                        }
                      >
                        <i className="ri-arrow-right-s-line"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </>
        )}
        </div>

        <StatusUpdateModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(!modalOpen)}
          orderDetailId={selectedRefNumber}
          currentStatus={selectedStatus}
          fetchOrderList={fetchOrderList}
        />
        <CancelModal
          isOpen={isModalOpen}
          toggle={toggleModal}
          onDeleteClick={handleCancel}
        />
      </div>
    </Container>
  );
};

export default OrderList;
